module.exports = __webpack_public_path__ + "static/media/support_art.eeacec51.svg";